<template>
	<drawer
			:title="titleDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<div class="infoUserVacation">
			<div class="infoTitle">Information on number of days</div>

			<item-info-row
					icon-id="Umbrella"
					text="Paid vacation:"
					:value="getVocation"
					is-value-icon
					value-icon="icon-day"
					value-icon-width="8px"
					value-icon-height="16px"
			></item-info-row>
			<item-info-row
					v-if="!isVacationCompensation && date.length"
					custom-class="iconColorGrey"
					icon-id="Umbrella"
					text="Total selected days"
					:value="date.length"
					is-value-icon
					value-icon="icon-day"
					value-icon-width="8px"
					value-icon-height="16px"
			/>

			<item-info-row
					v-if="!isVacationCompensation && date.length > vocationAll"
					custom-class="iconColorYellow"
					icon-id="Umbrella"
					text="Used at its own expense:"
					:value="date.length - vocationAll"
					is-value-icon
					value-icon="icon-day"
					value-icon-width="8px"
					value-icon-height="16px"
			/>
<!--			<item-info-row-->
<!--					icon-id="Medicine"-->
<!--					text="Sickleave:"-->
<!--					value="5"-->
<!--					is-value-icon-->
<!--					value-icon="icon-day"-->
<!--					value-icon-width="8px"-->
<!--					value-icon-height="16px"-->
<!--			></item-info-row>-->
		</div>

		<div
				:class="[
    'box',
    {
      'errorField': getError('date'),
      'box--disabled': isVacationCompensation
    }
  ]"
		>
			<div class="label">Select days</div>

			<div class="box__calendar-wrap">
				<div
						v-if="isVacationCompensation"
						class="box__calendar-overlay"
				>
					<div class="box__calendar-overlay-text">
						Date selection is unavailable for vacation compensation.
					</div>
				</div>

				<v-date-picker
						label="Select dateі"
						v-model="date"
						class="datePicker"
						color="green"
						prev-icon="mdi-menu-left"
						next-icon="mdi-menu-right"
						multiple
						no-title
						scrollable
						show-adjacent-months
						locale="en-en"
						:first-day-of-week="6"
						:weekday-format="getCustomDay"
						:readonly="isVacationCompensation"
						full-width
				/>
			</div>

			<div v-if="dateErrorText" class="error--text">
				{{ dateErrorText }}
			</div>
		</div>

		<field
				:class-error="!!noteErrorText"
				:text-error="noteErrorText"
				margin="10px 0 10px 0"
				width="300px"
				label="Note"
				placeholder="Enter note"
				:setInputValue="note"
				@updateInput="onInput($event, 'note')"
				is-textarea
				is-required
		/>

		<div
				v-if="isVacationAlertVisible && !isVacationCompensation"
				class="alertUserVacation"
		>
			📅 Vacation dates will be checked. Only two employees can be on vacation during calandar month.
		</div>

		<div
				v-if="
			    isVacationAlertVisible &&
			    !isVacationCompensation &&
			    vacationCheckError &&
			    vacationUsers.length
			  "
				class="listUserVacation"
		>
			<div class="listTitle">⚠️ People already scheduled for vacation in this period:</div>

			<div class="list">
				<div
						v-for="(u, idx) in vacationUsers"
						:key="`${u.userId}-${u.period}-${idx}`"
						class="listItem"
				>
					<div class="empWr">
						<svg-sprite icon-id="icon-user" width="18" height="18"/>
						<span class="employee">{{ u.employee }}</span>
					</div>
					<div class="periodWr">
						<svg-sprite icon-id="calendarAlt" width="18" height="18"/>
						<span class="period">{{ u.period }}</span>
						<span class="date">{{ u.date }}</span>
					</div>

				</div>
			</div>

			<div v-if="vacationSaveError" class="vacationErrorText">
				❌ You can’t request these dates — vacation limit reached. Please choose other days.
			</div>
		</div>

		<div
				v-if="isVacationCompensationAvailable"
				class="vacationCompensation"
		>
			<v-switch
					v-model="isVacationCompensation"
					label="Vacation compensation"
					color="green"
					:disabled="!hasVacationForCompensation"
					hide-details
			/>

			<div
					v-if="isVacationCompensation"
					class="vacationCompensation__count"
			>
				<field
						:class-error="!!countErrorText"
						:text-error="countErrorText"
						margin="10px 0 0 0"
						width="300px"
						label="Number of days"
						placeholder="Enter number of days"
						:setInputValue="count"
						@updateInput="onCompensationCountInput"
						is-required
						is-number
						type="number"
				/>
			</div>
		</div>

	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import { mapActions } from "vuex";
import getUserTimeZoneRegion from "@/helper/getUserTimeZoneRegion";
import formatDate from "@/helper/formatDate";

export default {
	name: "RequestVacation",
	mixins: [ validationMixin ],
	components: { ItemInfoRow, Drawer },
	computed: {
		// dateErrorText() {
		// 	if (!this.$v.date || !this.$v.date.$dirty) return '';
		// 	if (!this.$v.date.required) return '🗓️ Please select at least one day.';
		// 	return '';
		// },
		/**
		 * Returns available vacation days.
		 *
		 * @returns {number}
		 */
		availableVacationDays() {
			if (this.id) {
				return Number(
					this.activeItem &&
						this.activeItem.total_vocation
						? this.activeItem.total_vocation
						: 0
				);
			}

			return Number(this.totalVocation || 0);
		},

		noteErrorText() {
			if (!this.$v.note || !this.$v.note.$dirty) return '';
			if (!this.$v.note.required) return '📝 Please fill in the Note field.';
			return '';
		},
		getVocation() {
			const dd = this.date.length - this.vocationAll;
			if (dd < 0) return Math.abs(dd);
			return 0;
		},
		isVacationAlertVisible() {
			console.log('%c [  this.userData  ] ', 'color:#bada55', typeof this.userData, this.userData );
			const userId = Number(this.userData && this.userData.id);
			const departmentId = Number(this.userData && this.userData.department_id);

			return departmentId === 1 && userId !== 304;
		},

		isVacationCompensationAvailable() {
			// Админ, Сейфити и Сейфити Менеджер
			const allowedTypes = [ 3, 6, 7 ];
			const userType = Number(this.userData && this.userData.type);

			return allowedTypes.includes(userType);
		},

		hasVacationForCompensation() {
			return this.availableVacationDays > 0;
		},

		countErrorText() {
			if (!this.isVacationCompensation) return '';

			if (!this.$v.count || !this.$v.count.$dirty) return '';

			if (!this.$v.count.required) {
				return 'Please enter the number of vacation days.';
			}

			if (!this.$v.count.integer) {
				return 'Please enter a whole number.';
			}

			if (!this.$v.count.minValue) {
				return 'The number of days must be at least 1.';
			}

			if (!this.$v.count.maxValue) {
				return `You entered more vacation days than are available. You have ${ this.availableVacationDays } days available.`;
			}

			return '';
		},

		dateErrorText() {
			if (this.isVacationCompensation) return '';

			if (!this.$v.date || !this.$v.date.$dirty) return '';

			if (!this.$v.date.required) {
				return '🗓️ Please select at least one day.';
			}

			return '';
		},

		// ...
	},
	props: {
		activeItem: Object,
		totalVocation: Number,
		id: Number,
		userData: Object,
	},
	// validations: {
	// 	note: { required },
	// 	date: {
	// 		required(value) {
	// 			return value.length > 0;
	// 		},
	// 	},
	// },
	validations() {
		return {
			note: {
				required,
			},

			date: {
				required: value => {
					if (this.isVacationCompensation) {
						return true;
					}

					return Array.isArray(value) && value.length > 0;
				},
			},

			count: {
				required: value => {
					if (!this.isVacationCompensation) {
						return true;
					}

					return value !== '' && value !== null && value !== undefined;
				},

				integer: value => {
					if (!this.isVacationCompensation || value === '') {
						return true;
					}

					return /^\d+$/.test(String(value));
				},

				minValue: value => {
					if (!this.isVacationCompensation || value === '') {
						return true;
					}

					return Number(value) >= 1;
				},

				maxValue: value => {
					if (!this.isVacationCompensation || value === '') {
						return true;
					}

					return Number(value) <= this.availableVacationDays;
				},
			},
		};
	},

	data() {
		return {
			titleDrawer: 'Request vacation',
			note: '',
			date: [],
			vocation: 0,
			vocationAll: 0,

			isVacationCompensation: false,
			count: '',

			vacationUsers: [],
			vacationCheckError: false,
			vacationSaveError: false,
			vacationCheckTimer: null,
		};
	},
	methods: {
		...mapActions([
			'setCalendarEventsList',
			'getAccountUpdateVacationRequestEditPut',
			'getAccountVacationRequestList',
			'getAccountCheckVacationRequest',
		]),

		onCompensationCountInput({ value }) {
			const normalizedValue = String(value || '').replace(/\D/g, '');

			this.count = normalizedValue === ''
				? ''
				: Number(normalizedValue);

			this.$v.count.$touch();
		},

		/**
		 * Проверка отпуска: если бек вернул error=true — показываем весь список из res.
		 * @returns {Promise<void>}
		 */
		async checkVacation() {
			if (!this.isVacationAlertVisible || this.isVacationCompensation) {
				return;
			}

			try {
				const response = await this.getAccountCheckVacationRequest({ date: this.date });
				const data = response && response.data ? response.data : {};

				//  сначала нормализуем список
				const users = this.normalizeVacationUsers(data.res);

				//  ошибка если:
				// 1) бек вернул error=true
				// 2) ИЛИ найдено 2 и более записей
				this.vacationCheckError = !!data.error || users.length >= 2;

				// если ошибка — показываем список
				this.vacationUsers = this.vacationCheckError ? users : [];
			} catch (e) {
				this.vacationCheckError = false;
				this.vacationUsers = [];
				console.error(e);
			}
		},

		/**
		 * Преобразуем res в плоский список для вывода.
		 * @param {Object} res
		 * @returns {Array}
		 */
		normalizeVacationUsers(res) {
			const out = [];
			const safeRes = res || {};

			Object.keys(safeRes).forEach((userId) => {
				const periods = safeRes[userId] || {};

				Object.keys(periods).forEach((period) => {
					const item = periods[period];
					if (!item) return;

					out.push({
						userId,
						period,
						name: item.name,
						// ✅ форматируем дату для UI
						date: formatDate(item.date),
						employee: item.employee,
					});
				});
			});

			return out;
		},
		
		onDate(value) {
			this.date = value;
		},
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		// async onSave() {
		// 	this.$v.$touch();
		//
		// 	// ✅ если dept=1 и бек ранее сказал error=true — не даём сохранить
		// 	if (this.isVacationAlertVisible && this.vacationCheckError) {
		// 		this.vacationSaveError = true;
		// 		return;
		// 	}
		//
		// 	if (!this.$v.$error) {
		// 		const id = this.id;
		// 		const type = id ? 1 : 0;
		// 		const { note, date } = this.$data;
		// 		if (type === 1) {
		// 			await this.getAccountUpdateVacationRequestEditPut({ id, note, date, type });
		// 			await this.getAccountVacationRequestList();
		// 		} else {
		// 			await this.setCalendarEventsList({ note, date, type });
		// 		}
		// 		this.note = '';
		// 		this.date = [];
		// 		this.$emit('updateClose');
		// 	} else {
		// 		this.$store.dispatch('setAlert', { type: "error", message: `🗓️✏️ Please select at least one day and fill in the Note field.` });
		// 	}
		// },

		async onSave() {
			this.$v.$touch();

			if (
				!this.isVacationCompensation &&
					this.isVacationAlertVisible &&
					this.vacationCheckError
			) {
				this.vacationSaveError = true;
				return;
			}

			if (this.$v.$error) {
				const message = this.isVacationCompensation
					? '✏️ Please fill in the Note field and enter a valid number of vacation days.'
					: '🗓️✏️ Please select at least one day and fill in the Note field.';

				this.$store.dispatch('setAlert', {
					type: 'error',
					message,
				});

				return;
			}

			const id = this.id;

			// Это существующий type для create/edit.
			const type = id ? 1 : 0;

			// Новый type_id для compensation.
			const typeId = this.isVacationCompensation ? 1 : 0;

			const payload = {
				note: this.note,
				date: this.isVacationCompensation ? [] : this.date,
				type,
				type_id: typeId,
			};

			if (this.isVacationCompensation) {
				payload.count = Number(this.count);
			}

			if (type === 1) {
				await this.getAccountUpdateVacationRequestEditPut({
					id,
					...payload,
				});

				await this.getAccountVacationRequestList();
			} else {
				await this.setCalendarEventsList(payload);
			}

			this.note = '';
			this.date = [];
			this.count = '';
			this.isVacationCompensation = false;

			this.$emit('updateClose');
		},

		// onClose() {
		// 	this.vacationUsers = [];
		// 	this.vacationCheckError = false;
		// 	this.vacationSaveError = false;
		//
		// 	this.$emit('updateClose');
		// },

		onClose() {
			clearTimeout(this.vacationCheckTimer);

			this.vacationUsers = [];
			this.vacationCheckError = false;
			this.vacationSaveError = false;

			this.isVacationCompensation = false;
			this.count = '';

			this.$v.$reset();

			this.$emit('updateClose');
		},

		onInput({ value }, key) {
			this[key] = value;
		},
		onAutocomplete({ value }, key) {
			this[key] = value.id;
		},
		onCheckbox({ value }, key) {
			this[key] = value;
		},
		getCustomDay(date) {
			const timeZone = getUserTimeZoneRegion();

			if (timeZone.region === 'america') {
				const daysOfWeek = [ 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Su', 'Sa' ];
				const i = new Date(date).getDay(date);
				return daysOfWeek[i];
			}

			const daysOfWeek = [ 'Sa', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Su' ];
			const i = new Date(date).getDay(date);
			return daysOfWeek[i];
		},
	},
	mounted() {
		if (this.userData.department_id === 1) {
			console.log('%c [  this.userData  ] ', 'color:#bada55', typeof this.userData, this.userData );
		}

		if (this.totalVocation) {
			this.vocationAll = this.totalVocation;
		}
		if (this.id) {
			const { note, date, total_vocation } = this.activeItem;
			this.note = note;
			this.date = date;
			this.vocation = total_vocation - date.length;
			this.vocationAll = total_vocation;
		}
	},
	watch: {
		// date: {
		// 	deep: true,
		// 	handler() {
		// 		if (!this.isVacationAlertVisible) return;
		//
		// 		// если даты стерли — чистим все статусы
		// 		if (!this.date || !this.date.length) {
		// 			this.vacationUsers = [];
		// 			this.vacationCheckError = false;
		// 			this.vacationSaveError = false;
		// 			return;
		// 		}
		//
		// 		// при любом изменении даты — сбрасываем ошибку сохранения
		// 		this.vacationSaveError = false;
		//
		// 		clearTimeout(this.vacationCheckTimer);
		// 		this.vacationCheckTimer = setTimeout(() => {
		// 			this.checkVacation();
		// 		}, 300);
		// 	},
		// },

		date: {
			deep: true,
			handler() {
				if (
					!this.isVacationAlertVisible ||
						this.isVacationCompensation
				) {
					return;
				}

				if (!this.date || !this.date.length) {
					this.vacationUsers = [];
					this.vacationCheckError = false;
					this.vacationSaveError = false;
					return;
				}

				this.vacationSaveError = false;

				clearTimeout(this.vacationCheckTimer);

				this.vacationCheckTimer = setTimeout(() => {
					this.checkVacation();
				}, 300);
			},
		},

		isVacationCompensation(value) {
			this.vacationUsers = [];
			this.vacationCheckError = false;
			this.vacationSaveError = false;

			if (!value) {
				this.count = '';

				if (this.$v.count) {
					this.$v.count.$reset();
				}
			}
		},

		availableVacationDays(value) {
			if (Number(value) <= 0) {
				this.isVacationCompensation = false;
				this.count = '';
			}
		},
	},

};

</script>

<style scoped lang="scss">
.infoUserVacation {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 14px;

	.infoTitle {
		font-weight: bold;
		color: #a3a3a3;
	}
}
.box {
	box-shadow: var(--card-shadow);
	border-radius: 4px;
	background: var(--card-bg);
	.label {
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		letter-spacing: 0.25px;
		color: #8F90A6;
		padding: 10px 10px 0 10px;

		&:after {
			content: '*';
			color: var(--base-red);
		}
	}

	&.errorField {
		.label {
			color: var(--base-red);
		}
	}

	.datePicker {
		background: transparent !important;
	}
	.error--text {
		color: var(--base-red);
		padding: 10px 10px 0 10px;
		font-size: 12px;
	}
}

.alertUserVacation {
	margin-top: 10px;
	font-size: 13px;
	color: var(--card-color-sub-title);
}

.listUserVacation {
	margin-bottom: 20px;
	.listTitle {
		margin: 15px 0;
	}
	.list {
		display: flex;
		flex-direction: column;
		gap: 10px;
		.listItem {
			svg {
				color: var(--base-green);
			}
			.empWr {
				display: flex;
				align-items: center;
				gap: 4px;
				font-size: 14px;
			}
			.periodWr {
				font-size: 13px;
				display: flex;
				align-items: center;
				gap: 4px;
				color: var(--base-orange);
			}
			.date {
				font-size: 12px;
				flex: 1;
				color: var(--card-color-sub-title);
			}
		}
	}

	.vacationErrorText {
		color: var(--base-red);
	}

}

</style>
<style lang="scss">
.box {
	position: relative;
	box-shadow: var(--card-shadow);
	border-radius: 4px;
	background: var(--card-bg);
	overflow: hidden;

	.label {
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		letter-spacing: 0.25px;
		color: #8F90A6;
		padding: 10px 10px 0 10px;

		&:after {
			content: '*';
			color: var(--base-red);
		}
	}

	&.errorField {
		.label {
			color: var(--base-red);
		}
	}

	.datePicker {
		background: transparent !important;
		transition: filter 0.2s ease, opacity 0.2s ease;
	}

	.box__calendar-wrap {
		position: relative;
	}

	.box__calendar-overlay {
		position: absolute;
		inset: 0;
		z-index: 3;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
		background: rgba(18, 21, 35, 0.24);
		backdrop-filter: blur(8px);
		-webkit-backdrop-filter: blur(8px);
	}

	.box__calendar-overlay-text {
		max-width: 260px;
		text-align: center;
		font-size: 14px;
		line-height: 20px;
		font-weight: 600;
		color: #ff9f43;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
	}

	&.box--disabled {
		.label {
			&:after {
				display: none;
			}
		}

		.datePicker {
			filter: blur(3px);
			opacity: 0.55;
			pointer-events: none;
			user-select: none;
		}
	}

	.error--text {
		color: var(--base-red);
		padding: 10px 10px 0 10px;
		font-size: 12px;
	}

	.v-picker__body.v-picker__body--no-title.theme--dark {
		margin: 0 !important;
		width: 100% !important;
	}
	table {
		tbody {
			tr {
				td {
					&:nth-of-type(1),
					&:nth-of-type(2) {
						button {
							color: #ff9898;
						}
					}
					//&:last-child,
					//&:first-child {
					//	button {
					//		color: #ff9898;
					//	}
					//}
				}
			}
		}
	}
}

/* Подсветка выходных */
.weekend-day {
	color: #ff9800 !important; /* Цвет текста */
	background-color: rgba(255, 152, 0, 0.2) !important; /* Подсветка */
	border-radius: 50%;
}

</style>
